import {GameAvalancheRespinState} from 'src/avalanche/states/GameAvalancheRespinState';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {RespinScatterInfo} from '@fantasmagames/slot/src/logic/SpinResult';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';

export class TopGameAvalancheRespinState extends GameAvalancheRespinState {

	protected onAddingNewFinished(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
	}

	protected onRespinFinished(): void {
		this.module.timeUtils.createTimer(() => {
			const respinScatters: RespinScatterInfo[] = (this.module.logic as GameRecodeLogic).getSpinResult().respinScatters;
			const removePositions: SymbolPosition[] = [];
			for (const scatterInfo of respinScatters) {
				removePositions.push(scatterInfo.respinScatterPosition);
				removePositions.push(...scatterInfo.respinSymbols);
			}

			(this.view as GameAvalancheReelsView).removeRespinSymbolsFromReels(removePositions);
			this.view.fillVoidAfterRemoval();
		}, 300);
	}

	protected onRespinSymbolsRemovalFinished(): void {
	}
}



// WEBPACK FOOTER //
// ./src/topreels/states/TopGameAvalancheRespinState.ts